import { render, staticRenderFns } from "./ModalBusinessUsePercentageEdit.vue?vue&type=template&id=65fab8ca&"
import script from "./ModalBusinessUsePercentageEdit.vue?vue&type=script&lang=js&"
export * from "./ModalBusinessUsePercentageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports